import React, {forwardRef, useEffect, useState} from 'react'
import s from './StatementTable.module.css'
import Table, {ColumnsType} from "antd/es/table";
import {ConfigProvider, Popover} from 'antd';
import {useAppSelector} from "../../../../../hooks/redux";
import {ITransaction, setTransactionsData} from "../../../../../store/reducers/TransactionsSlice/TransactionsSlice";
// import {ReactComponent as SortIconAsc} from "../../../../../assets/img/personalAccount/sortArrow.svg";
// import {ReactComponent as SortIconDesc} from "../../../../../assets/img/personalAccount/sortArrowDown.svg";
// import {ReactComponent as SortIcons} from "../../../../../assets/img/personalAccount/sortIcons.svg";
import info from "../../../../../assets/img/personalAccount/information.svg";
import PopoverContent from "./PopoverContent/PopoverContent";
import { GetTransactionsListThunk } from '../../../../../store/reducers/ActionCreators';
import { useAppDispatch } from '../../../../../store/store';
import {prepareTransferPaginationData} from "../../../../../helpers/PrepareTransferPaginationData";

const columns: ColumnsType = [
    {
        title: 'date',
        dataIndex: 'date',
        // sorter: true,
        className: `${s.dateCell}`,
        // sortIcon: (props: { sortOrder: any }) => {
        //     if (props.sortOrder === 'ascend') {
        //         return <SortIconAsc/>
        //     }
        //     if (props.sortOrder === 'descend') {
        //         return <SortIconDesc/>
        //     }
        //     return <SortIcons/>
        // }
    },
    {
        title: 'transfer №',
        dataIndex: 'transferN',
    },
    {
        title: 'payer',
        dataIndex: 'payer',
    },
    {
        title: 'recipient',
        dataIndex: 'recipient',
    },
    {
        title: 'type',
        dataIndex: 'type',
    },
    Table.EXPAND_COLUMN,
    {
        title: 'amount',
        dataIndex: 'amount',
        align: 'right',
        // sorter: true,
        // sortIcon: (props: { sortOrder: any }) => {
        //     if (props.sortOrder === 'ascend') {
        //         return <SortIconAsc/>
        //     }
        //     if (props.sortOrder === 'descend') {
        //         return <SortIconDesc/>
        //     }
        //     return <SortIcons/>
        // },
        className: `${s.amountColumn}`
    },
    {
        title: 'balance',
        dataIndex: 'balance',
        align: 'right'
    },
    {
        title: 'status',
        dataIndex: 'transactionStatus',
        align: 'right'
    },
];

interface StatementTableProps  {
    ref: HTMLDivElement | null
}

export const StatementTable = forwardRef<HTMLDivElement, StatementTableProps> ((props, ref) => {

    const [isMobile, setIsMobile] = useState(false)

    const dispatch = useAppDispatch()
    const userToken = useAppSelector(state => state.userReducer.userToken)
    const chosenAccountTypeId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const totalPages = useAppSelector(state => state.transactionsReducer.transactionsData.numberOfPages)
    const currentPage = useAppSelector(state => state.transactionsReducer.transactionsData.currentPage)
    const sortedTransactions = useAppSelector(state => state.transactionsReducer.transactionsData.transactions)

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
        return () => {
            dispatch(setTransactionsData({
                transactions: [],
                numberOfPages: 0,
                currentPage: 1
            }))
        }
    }, [])

    const chosenAccountData = useAppSelector(state => state.transactionsReducer.filters)
    const payerData = useAppSelector(state => state.userReducer.user.userData)
    const [isShowAllTransMob, setIsShowAllTransMob] = useState(false)
    const mobileTransView = isShowAllTransMob ? sortedTransactions : sortedTransactions?.slice(0, 1)

    const handlePageChange = (page: number) => {
        const tempData = prepareTransferPaginationData(chosenAccountData, page)
        dispatch(GetTransactionsListThunk(userToken, tempData, chosenAccountTypeId))
    }

    const tableData = sortedTransactions?.map((item: any) => {

        let date = item.created.split(" ")[0]
        let time = item.created.split(" ")[1]
        return {
            key: item.transactionNumber,
            date: <><p className={s.dateCellP}>{date}</p><p
                className={s.timeCellP}>{time}</p></>,
            transferN: item.transactionNumber,
            payer: <>
            {
                item.payerAccount
                    ? `${item.payerAccount} ${item.payerName}`
                    : `${item.fromAccountMainIban} ${payerData.firstName ? `${payerData.firstName} ${payerData.lastName}` : payerData.companyName}`
            }
            </> ,
            recipient: <>
                <div className={s.recipient_row}>
                    {  (item.recipient || item.toAccount) ?
                        <p>
                            {item.recipient ? item.recipient : item.toAccountUserName}
                        </p>
                        : <p>
                            {item?.recipientDetails?.beneficiaryAccountNumber}
                        </p>
                    }

                    {(item.recipientDetails && item.recipientDetails.length !== 0)
                        ?    <Popover  content={ <PopoverContent item={item}/>}
                                 color={'#EEEFEF'}
                                 overlayInnerStyle={{
                                     fontFamily: 'Manrope',
                                     minWidth: '370px',
                                     maxWidth: '350px',
                                     padding: '13px 16px',
                                     cursor: 'pointer',
                                     backgroundColor: '#E7F0EC'
                                 }}
                            >
                                <img src={info} alt=""/>
                            </Popover>
                        : null}

                </div>
            </>,
            type: <><p className={s.transaction_type}>{item.transactionType === "International" ? item.transactionSubType : item.transactionType}</p></>,
            amount: <p
                className={item.direction === 'IN' ? `${s.in}` : `${s.out}`}>{item.direction === 'OUT' && '-'}{item.amount + ' ' + item.currency}</p>,
            balance: item.balance + ' ' + item.currency,
            transactionStatus: <>
                <p>
                    {
                        item.transactionStatus === 'Canceled' && <p className={s.rejected}>Rejected</p>
                    }
                    {
                        item.transactionStatus === 'New' || item.transactionStatus === 'Pending' ? <p className={s.pending}>Pending</p> : null
                    }
                    {
                        item.transactionStatus === 'Completed' && <p className={s.confirmed}>Completed</p>
                    }
                    {
                        item.transactionStatus === 'Refunded' && <p className={s.refunded}>Refunded</p>
                    }
                </p>
                {
                    item.transactionStatus === 'Canceled' &&
                    item.deniedReason &&
                    <p className={s.reason}>({item.deniedReason})</p>
                }

            </>,
            description: 'test'
        }
    })

    return (
        <div className={s.tableWrapper} style={{flexDirection: 'column'}} ref={ref}>


            {
                isMobile
                    ?
                    <>

                    <div className={s.transactionsListMobile}>
                        {
                            mobileTransView.map((item: ITransaction) =>
                                <div key={item.transactionNumber} className={s.transfer}>

                                    <div className={s.mobileTransferRow}>
                                        <div className={s.mobileTransferBlock}>
                                            <div className={s.blockTitle}><span>Date</span></div>
                                            <p className={s.dateCellP}>{item.created.split(" ")[0]}</p><p
                                            className={s.timeCellP}>{item.created.split(" ")[1]}</p>
                                        </div>
                                        <div>
                                            <div className={s.blockTitle}><span>Transfer №</span></div>
                                            <p className={s.dateCellP}>{item.transactionNumber}</p>
                                        </div>
                                    </div>

                                    <div className={s.mobileTransferRow}>
                                        <div className={s.mobileTransferBlock}>
                                            <div className={s.blockTitle}><span>Type</span></div>
                                            <p className={s.dateCellP}>{item.transactionType === "International" ? item.transactionSubType : item.transactionType}</p>
                                        </div>
                                    </div>

                                    <div className={s.mobileTransferRow}>
                                        <div className={s.mobileTransferBlock}>
                                            <div className={s.blockTitle}><span>Payer</span></div>
                                            <p className={s.dateCellP}>
                                                {payerData.clientId} {payerData.firstName} {payerData.lastName} {payerData.companyName}
                                            </p>
                                        </div>
                                    </div>

                                    <div className={s.mobileTransferRow}>
                                        <div className={s.mobileTransferBlock}>
                                            <div className={s.blockTitle}><span>Recipient</span></div>
                                            <p className={s.dateCellP}>
                                                {  (item.recipient || item.toAccount) ?
                                                    <p>
                                                        {item.recipient ? item.recipient : item.toAccountUserName}
                                                    </p>
                                                    : <p>
                                                        {item?.recipientDetails?.beneficiaryAccountNumber}
                                                    </p>
                                                }
                                            </p>
                                        </div>
                                    </div>

                                    <div className={s.mobileTransferRow}>
                                        <div className={s.mobileTransferBlock}>
                                            <div className={s.blockTitle}><span>Amount</span></div>
                                            <p className={item.direction === 'IN' ? `${s.in}` : `${s.out}`}>
                                                {item.direction === 'OUT' && '-'}
                                                {item.amount + ' ' + item.currency}
                                            </p>
                                        </div>
                                        <div>
                                            <div className={s.blockTitle}><span>Balance</span></div>
                                            <p className={s.dateCellP}>{item.balance} {item.currency}</p>
                                        </div>
                                    </div>

                                    <div className={s.mobileTransferRow}>
                                        <div className={s.mobileTransferBlock}>
                                            <div className={s.blockTitle}><span>Status</span></div>
                                            {
                                                item.transactionStatus === 'Canceled' && <p className={s.rejected}>Rejected</p>
                                            }
                                            {
                                                item.transactionStatus === 'New' || item.transactionStatus === 'Processed' ? <p className={s.pending}>Pending</p> : null
                                            }
                                            {
                                                item.transactionStatus === 'Completed' && <p className={s.confirmed}>Completed</p>
                                            }
                                        </div>
                                    </div>

                                </div>
                            )}
                    </div>
                    {sortedTransactions.length !== 0 ?
                    <>
                        <div className={s.headerWrapper} >
                            <div className={s.infoWrapper}>
                                <p className={s.line}>Account number: <b>{chosenAccountData.accountNumber}</b></p>
                                <p className={s.line}>Currencies: <b>
                                    {chosenAccountData.currency}
                                </b></p>
                                <p className={s.line}>Period: from <b>{chosenAccountData.from}</b> to <b>{chosenAccountData.to}</b>
                                </p>
                            </div>
                                {/*<p className={s.balance}>Start balance: <span>11.88 USD</span></p>*/}
                        </div>
                        <div className={s.transactionContentWrapper} onClick={() => setIsShowAllTransMob((prevent) => !prevent)}>{isShowAllTransMob ? 'Close' : 'See all account statements'} <span className={isShowAllTransMob ? `${s.arrowList} ${s.arrowDown}` : ` ${s.arrowList}`}></span> </div>
                    </> : null }

                    </>
                    : <ConfigProvider theme={{
                        components: {
                            Pagination: {
                                colorPrimary: '#FFFFFF',
                                colorPrimaryHover: '#FFFFFF',
                                colorBgContainer: '#4DB887',
                                colorLink: '#FFFFFF'
                            },
                        },
                    }}>
                        <Table
                            bordered={false}
                            style={{marginTop: 48}}
                            rowClassName={(record, index) => index % 2 !== 0 ? `${s.table_row_dark}` : ''}
                            className={s.statementTable}
                            columns={columns}
                            pagination={{
                                position: ['bottomCenter'],
                                defaultPageSize: 15,
                                onChange: handlePageChange,
                                total: totalPages * 15,
                                current: currentPage,
                                showSizeChanger: false
                                }}
                            //for info
                            /*expandable={{
                                expandIcon: ({expanded, onExpand, record}) =>
                                    (<img src={arrowDown} className={expanded ? s.open : s.close}
                                          onClick={e => onExpand(record, e)}/>)
                                ,
                                expandedRowRender: (record) => <p style={{margin: 0}}>{record.description}</p>,
                                expandRowByClick: true,

                            }}*/
                            dataSource={tableData}
                        />

                    </ConfigProvider>
            }

            {/*<ul className={s.summaryWrapper}>*/}
            {/*    <li className={s.summaryLine}><p className={s.summaryTitle}>Credit turnover:</p><p className={`${s.summaryValue} ${s.in}`}>5.49 USD</p></li>*/}
            {/*    <li className={s.summaryLine}><p className={s.summaryTitle}>Debit turnover:</p><p className={`${s.summaryValue} ${s.out}`}>-5.49 USD</p></li>*/}
            {/*    <li className={s.summaryLine}><p className={s.summaryTitle}>Fiat balance:</p><p className={`${s.summaryValue} ${s.sum}`}>11.88 USD</p></li>*/}
            {/*</ul>*/}
        </div>
    )
})
